module.exports = __webpack_public_path__ + "img/bbc.58fc512e.svg";